import React, { useState, useContext, useEffect } from 'react'

import Switch from './UI/Switch'
import { LanguageContext } from '../context'

const CookiesModal = ({ showModal, onAccept, onClose }) => {
  const { t } = useContext(LanguageContext)
  const [analytics, setAnalytics] = useState(false)

  const saveCookies = (type = '') => {
    let obj
    switch (type) {
      case 'all':
        obj = { required: true, tracking: true }
        break
      case 'necessary':
        obj = { required: true, tracking: false }
        break
      case '':
        obj = { required: true, tracking: analytics }
        break
      default:
        obj = { required: true, tracking: analytics }
    }

    onAccept(obj)
  }

  return (
    <div className={`w-full ${showModal ? '' : 'hidden'}`}>
      <div
        className="justify-center items-center z-60 rounded-lg modal-container no-padding">
        <div className="cookies-modal__body px-8 py-8">
          <div className="cookies-modal__body_section">
            <div className="cookies-modal__body_section-top">
              <div className='mb-4 flex w-full justify-between items-center'>
                <label className='mb-2'>
                  {t('cookies.toggle_4')}
                </label>
                <label className="switch">
                  <input type='checkbox' disabled checked />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
            <p className="cookies-modal__body_section-text">{t('cookies.toggle_4_text')}</p>
          </div>
          <div className="cookies-modal__body_section">
            <div className="cookies-modal__body_section-top">
              {/* <p>{t('cookies.toggle_5')}</p>
              <Switch onChange={(e) => setAnalytics(e.target.checked)} checked={analytics} /> */}
              <div className='mb-4 flex w-full justify-between items-center'>
                <label className='mb-2'>
                  {t('cookies.toggle_5')}
                </label>
                <label className="switch">
                  <input type='checkbox' onChange={(e) => setAnalytics(e.target.checked)} checked={analytics} />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
            <p className="cookies-modal__body_section-text">{t('cookies.toggle_5_text')}</p>
          </div>
          <button className='w-full' onClick={saveCookies}>{t('cookies.save')}</button>
        </div>
      </div>
      <div className="fixed inset-0 z-50 modal-bg" onClick={onClose}></div>
    </div>
  )
}

export default CookiesModal